/* Coria · trecere UX · /pages/wishlist: pagina era goala (favoritele se deschid intr-un dialog din coria-catalog-pro.js).
   1. Daca pagina nu are continut, punem o stare goala care explica unde sunt favoritele si le deschide
      (butonul are data-cp-open-favorites, deci il preia handlerul existent, acelasi ca inimioara din meniu).
   2. Daca exista favorite salvate, deschidem automat dialogul existent, O SINGURA DATA la incarcare,
      prin API-ul public window.CoriaCatalog.lists(). Focusul e pus intai pe butonul nostru, ca dialogul
      sa il tina minte si sa il redea la inchidere (Esc / X). Fara bucle: cel mult 10 incercari cat asteptam API-ul. */
(function () {
  'use strict';
  if (!/\/pages\/(wishlist|favorite)\/?$/.test(location.pathname)) return;
  var KEY = 'coria_salon_lists_v1'; // aceeasi cheie ca in coria-catalog-pro.js; doar numaram, nu interpretam
  var autoDone = false;

  function savedCount() {
    try {
      var x = JSON.parse(localStorage.getItem(KEY) || '{}');
      if (!x || !Array.isArray(x.lists)) return 0;
      return x.lists.reduce(function (n, l) { return n + (l && Array.isArray(l.items) ? l.items.length : 0); }, 0);
    } catch (_) { return 0; }
  }

  function autoOpen(btn, tries) {
    if (autoDone) return;
    var api = window.CoriaCatalog;
    if (!api || typeof api.lists !== 'function') {
      if (tries < 10) setTimeout(function () { autoOpen(btn, tries + 1); }, 300);
      return;
    }
    autoDone = true;
    if (btn) btn.focus({ preventScroll: true });
    try { api.lists(); } catch (_) { /* dialogul ramane accesibil din buton */ }
  }

  function run() {
    var host = document.querySelector('.section-main-page .main-page--wrapper');
    if (!host || host.textContent.trim() || host.querySelector('.cfux-wl')) return;
    var n = savedCount();
    var box = document.createElement('section');
    box.className = 'cfux-wl';
    box.setAttribute('aria-labelledby', 'cfux-wl-t');
    box.innerHTML =
      '<span class="cfux-wl__ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 20s-7-4.4-9.2-8.6C1.3 8.5 3 5 6.4 5c2 0 3.3 1.1 4 2.3h3.2C14.3 6.1 15.6 5 17.6 5 21 5 22.7 8.5 21.2 11.4 19 15.6 12 20 12 20z"/></svg></span>' +
      '<h2 id="cfux-wl-t">Favoritele tale</h2>' +
      (n > 0
        ? '<p>Ai ' + (n === 1 ? 'un produs salvat' : n + ' produse salvate') + ' pe acest dispozitiv.</p>'
        : '<p>Apasa pe inimioara de pe orice produs ca sa il pastrezi aici. Le gasesti oricand din inimioara din meniu.</p>') +
      '<div class="cfux-wl__act">' +
      '<button type="button" data-cp-open-favorites aria-haspopup="dialog">Deschide favoritele</button>' +
      '<a href="/collections/all">Descopera produse</a>' +
      '</div>';
    host.appendChild(box);
    /* 20.10.2026: favoritele apar acum ca si carduri (coria-ux-favorite.js), deci dialogul nu se mai deschide singur */
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
